import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
// components
import PageSearch from "@/components/PageSearch";
import MNPG from "./MNPG";
// type
import { TMainPageLayoutV3 } from "../type";
import TOutletContext from "@/cms/types/TOutletContext";
import { metaDataLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";


const MNPG019 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG019.rendered: ", props);

    const { _showLoader, contentId } = useOutletContext<TOutletContext>();

    useEffect(() => { return () => { _showLoader(); }},[]);
    
    if ( !props.template ) return null;

    const unqKey = contentId.split("-")[4];
    const orderBy = metaDataLanguageVersion("orderBy",props.template.languageVersions)

    return (
        <PageSearch filters={[`contentId eq ${contentId}`]} sort={orderBy} unqKey={unqKey}>
            <MNPG 
                templates={props.templates} 
                mapLayoutName={props.template.mapLayoutName} 
                parentId={props.template.id}
            />
        </PageSearch>
    )
}

export default MNPG019;
